import React from 'react';
import { themeMeta } from '../theme';

function ThemeBadge({ value, className = '' }) {
  const meta = themeMeta(value);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${meta.badge} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}

export default ThemeBadge;
